/******************************************************************************************
 *	Search Component
 *******************************************************************************************
 *
 * Search component with optional narrow-down options popover.
 * Specifying data for narrowDownOptions will created a popover with the options.
 * Specifying an initialQuery will pre-fill and expand the search input.
 *
 */
(function() {
  

  angular.module('rcDirectives.search', []).directive(
    'rcSearch',
    /* @ngInject */
    function(_, $log, $rootScope, DemoMode, DomUtility, Languages) {
      return {
        replace: true,
        templateUrl: 'templates/search.html',
        scope: {
          initialQuery: '@',
          narrowDownOptions: '=',
          disableButton: '=',
          onSubmit: '&',
          onCancel: '&'
        },
        link: function(scope, element, attrs) {
          //Cache DOM elements
          var inSearch = angular.element(element[0].querySelector('.search-input'));
          var narrowDownList = angular.element(element[0].querySelector('.js-narrow-down-list'));

          //The submittedSearch var is used to know if the user submitted at least one search term.
          //If between opening and closing the search interface, no search term was submitted, no data will be requested from the server after closing.
          //However, if at least one search term was submitted, data will be requested when closing the search interface.
          var submittedSearch = false;

          //Check if narrowDownOptions was passed-in, otherwise, the dropdown logic will be removed
          var hasNarrowDownOptions = !!scope.narrowDownOptions;

          //If isAlwaysExpanded is true, the search component UI is never contracted
          var isAlwaysExpanded = attrs.hasOwnProperty('alwaysExpanded');
          if (isAlwaysExpanded) {
            element.addClass('expanded no-animation');
          }

          //Clean-up UI and submit search by calling the onSubmit() expression
          var attemptSubmit = function() {
            if (!isValidSearchQuery()) {
              inSearch.addClass('error');
            } else {
              submittedSearch = true;
              inSearch.removeClass('error');
              var search = parseQueryString(inSearch.val());

              scope.onSubmit({query: search.query, field: search.filter});

              //It would seem that the digest is triggered on $rootScope when called from inside the scope.searchIconClick() method.
              if (!$rootScope.$$phase) {
                $rootScope.$apply();
              }
            }
          };

          //Toggle search state
          scope.isExpanded = isAlwaysExpanded;
          var expandSearch = function(preventInputFocus) {
            scope.isExpanded = true;

            //Hacky way of focusing on the element after transitions are done
            if (!preventInputFocus) {
              setTimeout(function() {
                inSearch[0].focus();
              }, 0);
            }
          };
          var compressSearch = function() {
            scope.isExpanded = false;

            //So that the blur handler isn't fired in the same $$phase
            setTimeout(function() {
              inSearch[0].blur();
            }, 0);
          };

          //Clear search input value and error class
          var resetSearchInput = function() {
            inSearch.val(''); //Clear search term
            inSearch.removeClass('error'); //Clear error state
          };

          //Close search: compress and clear input value
          scope.close = function() {
            resetSearchInput();

            //If user submitted at least one search term, request new data from server when closing search interface
            if (submittedSearch) {
              submittedSearch = false;
              scope.onCancel();
            }

            if (!isAlwaysExpanded) {
              compressSearch();
            }
          };

          //Click handler for magnifying glass icon
          scope.searchIconClick = function() {
            if (DemoMode.isEnabled()) {
              $log.info('%cFunction blocked in DEMO MODE.', 'color:#CCCCCC;');
              return;
            }

            //Expand search UI if compressed
            if (!scope.isExpanded) {
              expandSearch();
            } else {
              //Otherwise, submit search
              attemptSubmit();
            }
          };

          //Check if search input is valid
          var isValidSearchQuery = function() {
            var search = inSearch.val();

            var query = parseQueryString(search).query;

            if (!query) {
              return false;
            }

            query = _.trim(query);
            return query.length >= Languages.minSearchLength();
          };

          //Keydown handler for search input
          var keydownHandler = function(event) {
            var keyCode = DomUtility.getKeyCode(event);

            if (keyCode === 13) {
              //Enter key
              //Prevent default so that IE doesn't toggle sidebar instead of performing search
              //IE bug to with IE selecting the first button (type="button") it finds and triggering it on Enter key press
              event.preventDefault();

              attemptSubmit();
            } else if (keyCode === 27) {
              //Esc key
              scope.$apply(function() {
                scope.close();
              });
            }
          };
          inSearch.on('keydown', keydownHandler); //Must use keydown to prevent IE from firing it on the sidebar toggle button on Enter key press

          //If an initial query is specified, set the inSearch's value to it and expand the searchbar
          if (scope.initialQuery) {
            inSearch.val(scope.initialQuery);
            expandSearch(true);
            submittedSearch = true; //Trigger server call when search is cancelled
          }

          //Keyup handler for search input
          //At keydown, the pressed key isn't part of the search input string.
          var keyupHandler = function(event) {
            var keyCode = DomUtility.getKeyCode(event);

            ////Except for Enter and Esc keys, check string validity to show or hide the narrow-down list
            if (keyCode !== 13 && keyCode !== 27) {
              if (isValidSearchQuery()) {
                inSearch.removeClass('error');
                if (hasNarrowDownOptions) {
                  showNarrowDownList();
                }
              } else if (hasNarrowDownOptions) {
                hideNarrowDownList();
              }
            }
          };
          inSearch.on('keyup', keyupHandler); //Must use keydown to prevent IE from firing it on the sidebar toggle button first

          if (hasNarrowDownOptions) {
            //Focus handler
            var focusHandler = function() {
              if (isValidSearchQuery()) {
                showNarrowDownList();
              }
            };
            inSearch.on('focus', focusHandler);

            //Blur handler
            var blurHandler = function() {
              hideNarrowDownList();
            };
            inSearch.on('blur', blurHandler);

            //Toggle Narrow Down List Visibility
            var showNarrowDownList = function() {
              scope.showNarrowDownList = true;

              if (!scope.$$phase) {
                scope.$apply();
              }
            };
            var hideNarrowDownList = function() {
              scope.showNarrowDownList = false;

              if (!scope.$$phase) {
                scope.$apply();
              }
            };

            //Cache all possible narrow-down filters
            var arNarrowDownFilters = [];
            if (scope.narrowDownOptions) {
              arNarrowDownFilters = _.map(scope.narrowDownOptions, 'filter');
            }

            //Narrow-down list click event handlers
            var narrowDownFilterLinkClick = function(event) {
              //Narrow-down filter link clicked
              var requestedFilter = event.target.getAttribute('data-filter');
              if (requestedFilter) {
                event.preventDefault();

                var searchTerm = inSearch.val();

                //Check if searchTerm is prefixed
                var currentFilter = parseQueryString(searchTerm, true).filter;

                if (currentFilter) {
                  //Already a filter set, replace
                  searchTerm = _.replace(searchTerm, currentFilter, requestedFilter);
                } else {
                  //No filter set, prepend
                  searchTerm = requestedFilter + ': ' + searchTerm;
                }

                inSearch.val(searchTerm);

                //Submit on selection
                inSearch[0].blur(); //Trigger blur on input
                attemptSubmit();
              }
            };
            narrowDownList.on('click', narrowDownFilterLinkClick);

            //Preventing default mousedown action on the narrowdownList element prevents the blur event from firing on inSearch element.
            //This is needed because the blur handler removes the filters list before the click event would happen.
            var narrowDownCancelMousedown = function(event) {
              event.preventDefault();
            };
            narrowDownList.on('mousedown', narrowDownCancelMousedown);
          }

          //Parse a string and return an object containg the filter and the query, e.g. "player: Rooney" would return {query:'Rooney',filter:'player'}
          //If ignoreFilterValidity is set to true, the filter value will not be checked against the list of available filters
          var parseQueryString = function(str, ignoreFilterValidity) {
            if (!str) {
              return {query: str, filter: null};
            }

            //If separator doesn't exist or if there's no narrow-down options, the query is the string
            var separatorPosition = str.indexOf(':');
            if (!hasNarrowDownOptions || separatorPosition === -1) {
              return {query: str, filter: null};
            } else {
              var query = _.trim(str.substr(separatorPosition + 1));
              var filter = _.trim(str.substr(0, separatorPosition));

              //If filter value is present in the arNarrowDownFilters array, split the str param.
              //Otherwise consider the entire str to be the query.
              if (ignoreFilterValidity || _.includes(arNarrowDownFilters, filter)) {
                return {query: query, filter: filter};
              } else {
                return {query: str, filter: null};
              }
            }
          };

          //Clean-up
          scope.$on('$destroy', function() {
            inSearch.off('keydown', keydownHandler);
            inSearch.off('keyup', keyupHandler);
            inSearch.off('focus', focusHandler);
            inSearch.off('blur', blurHandler);
            narrowDownList.off('click', narrowDownFilterLinkClick);
            narrowDownList.off('mousedown', narrowDownCancelMousedown);
          });
        }
      };
    }
  );
})();
